import React, { useEffect, useRef } from 'react';

const UserActionsDropdown = ({
  user,
  onAction,
  onClose,
  position,
  menuClassName,
  menuStyle,
  backdrop,
  backdropClassName,
}) => {
  const menuRef = useRef(null);

  useEffect(function() {
    const handleClickOutside = function(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return function() {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  if (!user) return null;

  const menuItems = [
    { key: 'deposit', label: 'Deposit', action: 'deposit' },
    { key: 'withdraw', label: 'Withdrawn', action: 'withdraw' },
    { key: 'inactive', label: user.isActive ? 'Inactive' : 'Active', action: 'toggleStatus' },
    { key: 'blockMarket', label: 'Block/Unblock Market', action: 'blockMarket' },
    { key: 'edit', label: 'Edit', action: 'edit', isLink: true },
    { key: 'statement', label: 'Statement', action: 'statement', isLink: true },
    { key: 'accountOps', label: 'Account Operations', action: 'accountOps', isLink: true },
    { key: 'loginReport', label: 'Login Report', action: 'loginReport', isLink: true },
    ...(user.userType === 'Agent' ? [{ key: 'commissionReport', label: 'Commission len den', action: 'commissionReport', isLink: true }] : []),
    { key: 'resetPassword', label: 'Reset Password', action: 'resetPassword' },
  ];

  return (
    <>
      {backdrop && (
        <div className={backdropClassName} onClick={onClose} />
      )}
      <ul
        ref={menuRef}
        className={menuClassName}
        style={menuStyle}
        role="menu"
      >
        {menuItems.map(function(item) {
          const isLinkItem = item.isLink;
          return (
            <li
              key={item.key}
              role="menuitem"
              tabIndex={-1}
              onClick={function() {
                onAction(item.action, user);
              }}
            className={
              'px-3 py-2 text-sm cursor-pointer transition-colors hover:bg-gray-100 ' +
              (isLinkItem ? 'font-semibold text-gray-800' : 'text-gray-700')
            }
              style={{ lineHeight: '22px' }}
            >
              <span>{item.label}</span>
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default UserActionsDropdown;
